var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPMonitoring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M176.865 162.724c-31.844 0-57.749 25.905-57.749 57.749 0 31.854 25.905 57.759 57.749 57.759s57.759-25.905 57.759-57.759c0-31.844-25.915-57.749-57.759-57.749z",
    fill: "#111f3e",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.624 35.199H18.366C8.223 35.199 0 43.422 0 53.566v294.393c0 10.143 8.222 18.366 18.366 18.366h8.718l82.075-82.075c2.047-2.047 2.248-5.337.39-7.558-13.346-15.956-21.141-36.705-20.376-59.255 1.573-46.358 39.599-83.801 85.976-84.69 49.834-.956 90.552 39.853 89.447 89.709-1.03 46.415-38.611 84.32-85.016 85.728-13.917.423-27.132-2.417-38.956-7.802a5.61 5.61 0 0 0-6.301 1.126l-64.826 64.817h424.127c10.138 0 18.376-8.238 18.376-18.366V53.576c0-10.128-8.238-18.377-18.376-18.377zM318.218 295.588c0 8.288-6.709 14.997-14.997 14.997-8.278 0-14.997-6.709-14.997-14.997V237.71c0-8.278 6.719-14.997 14.997-14.997 8.288 0 14.997 6.719 14.997 14.997v57.878zm46.991 0c0 8.288-6.709 14.997-14.997 14.997-8.278 0-14.997-6.709-14.997-14.997V137.729c0-8.278 6.719-14.997 14.997-14.997 8.288 0 14.997 6.719 14.997 14.997v157.859zm47.77 0c0 8.288-6.719 14.997-14.997 14.997-8.288 0-14.997-6.709-14.997-14.997V177.721c0-8.278 6.709-14.997 14.997-14.997 8.278 0 14.997 6.719 14.997 14.997v117.867zm47.801 0c0 8.288-6.719 14.997-14.997 14.997-8.288 0-14.997-6.709-14.997-14.997v-77.875c0-8.278 6.709-14.997 14.997-14.997 8.278 0 14.997 6.719 14.997 14.997v77.875zM376.074 447.979l-.1-.043c-23.317-9.998-47.475-16.964-72.21-20.875v-28.462a5.61 5.61 0 0 0-5.61-5.61H213.846a5.61 5.61 0 0 0-5.61 5.61v28.498c-24.599 3.908-48.625 10.837-71.817 20.766-7.433 3.182-11.344 11.676-8.477 19.236 3.047 8.036 12.138 11.838 19.95 8.479 34.354-14.759 70.733-22.25 108.124-22.264h.313c37.072 0 73.756 7.548 107.817 22.184l.188.081a14.937 14.937 0 0 0 5.914 1.222c6.93-.001 13.462-4.833 14.829-12.599 1.195-6.803-2.655-13.502-9.003-16.223z",
    fill: "#111f3e",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.085 366.324 4.574 388.88c-5.859 5.859-5.859 15.347 0 21.206a14.951 14.951 0 0 0 10.608 4.389c3.839 0 7.679-1.46 10.598-4.389l43.716-43.762H27.085z",
    fill: "#111f3e",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPMonitoring);
export default __webpack_public_path__ + "static/media/PMonitoring.116d73521aaef451773e437ea2ef69bb.svg";
export { ForwardRef as ReactComponent };